import styled, { css } from "styled-components"

import FunctionLink from "~/components/atoms/FunctionLink"
import { Color, IsMobile, RadiusSize, Shadow, SpacingSize, TextSize, LineHeight } from "~/consts/style-mixins"

export const ScheduleContainer = styled.div`
  margin-top: ${SpacingSize["3XL"]}px;
  line-height: ${LineHeight.L}%;
`
export const Schedule = styled.div`
  display: grid;
  grid-template-columns: 56px 1fr;
  ${IsMobile(css`
    grid-template-columns: 40px 1fr;
  `)}
`

export const ScheduleTimeLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ScheduleTimeLine = styled.div`
  width: 2px;
  height: 100%;
  background-color: ${Color.LightGray};
`

export const ScheduleTimeLinePoint = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background: ${Color.White};
  border: 2px solid ${Color.Primary};
`

export const ScheduleBoxContainer = styled.div`
  margin-bottom: ${SpacingSize.XL}px;
  border-radius: ${RadiusSize.Small}px;
  ${Shadow.Shallow};

  display: flex;
  flex-direction: row;
  align-items: center;
  ${IsMobile(css`
    flex-direction: column;
  `)}
`
export const ScheduleBox = styled.div`
  padding: ${SpacingSize.M}px;
`
export const ScheduleBoxTitle = styled.div`
  display: flex;
  font-size: ${TextSize.M}px;
  font-weight: bold;
  ${IsMobile(`
    font-size: ${TextSize.S}px;
  `)}
`

export const ScheduleBoxTitleTime = styled.div`
  color: ${Color.Primary};
`

export const ScheduleBoxTitleText = styled.div`
  margin-left: ${SpacingSize.XS}px;
`

export const ScheduleBoxDescription = styled.div`
  margin-top: ${SpacingSize.XS}px;
  ${IsMobile(`
    font-size: ${TextSize.XS}px;
    line-height: ${LineHeight.M}%;
  `)}
`

export const ScheduleBoxImage = styled.img`
  width: 248px;
  height: 140px;
  margin: ${SpacingSize.M}px;
  margin-left: ${SpacingSize.XL}px;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: ${RadiusSize.Medium}px;
  order: 1;
  ${IsMobile(css`
    width: 100%;
    height: auto;
    margin: 0;
    margin-left: 0;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    order: -1;
  `)}
`

export const ScheduleSeparate = styled.div`
  margin-bottom: ${SpacingSize.M}px;
`

export const MoreButtonWrapper = styled.div`
  text-align: center;
`

export const MoreButton = styled(FunctionLink)`
  width: 200px;
  line-height: 16px;
`
